import React from 'react';
import './styles.scss';

const MobileModal = ({
  children, //TODO: user children for body,
  showXIcon = true,
  onClose,
}) => {
  return (
    <div className='modal'>
      <div
        className='modal__content'
        style={{
          width: '90vw',
        }}
      >
        <div className='modal__content-head'>
          {showXIcon && (
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={onClose}
            />
          )}
        </div>
        <div
          className='modal__content-body'
          style={{display: 'flex', justifyContent: 'center'}}
        >
          {children}
        </div>
      </div>
      <div className='modal__bg' onClick={onClose}></div>
    </div>
  );
};

export default MobileModal;
